// The loop family's machine-made KEY CATALOGUE rows, all `'omit'`. Split out of `loop.ts`
// purely for size (biome's 800-line file cap), the `loop-billing-ownership.ts` posture:
// this group is spread into `TERMINAL_RENDERERS_LOOP`, so the family's partition and
// coverage tests see it where the vocabulary (`../../audit/kind-loop.ts`) puts it.
//
// `billing.key.limits_changed`: a machine-detected sync of a provider's advertised
// window/ceiling (`byok-reverify.lane.ts`'s reverify sweep, or a fleet run's own overflow
// refusal) — no operator decided anything, and the row carries no rendering
// verb-worthy content beyond "a number moved".
//
// `billing.key.models_synced` (#7810): the catalogue sync added, delisted or relisted
// models from the provider's own `/models` answer. Machine-made, like the one above.
//
// `billing.key.model_edited` (#7810): a person set one model's tier or active flag. It
// is read back on the key's own catalogue (`billing keys_list`) and in the audit trail,
// and gets a terminal line when a consumer asks for one.

import { terminalRendererGroup } from '../../../wire/terminal';

export const TERMINAL_RENDERERS_KEY_MODELS = terminalRendererGroup({
  'billing.key.limits_changed': 'omit',
  'billing.key.models_synced': 'omit',
  'billing.key.model_edited': 'omit',
});
